import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import { Bell } from 'lucide-react';
import l from '../../../../lang';
import { useDashboard } from '../../../../store/dashboard';
import { updateNotificationPreferences } from '../../../../store/profile/actions';
import './styles.scss';

const NotificationPreferences = ({ loading, fnUpdateNotificationPreferences }) => {
  const { userMe } = useDashboard();
  const enabled = Boolean(userMe?.notificationPreferences?.transaction_completed_email);
  const [optimisticEnabled, setOptimisticEnabled] = useState(null);
  const isEnabled = optimisticEnabled !== null ? optimisticEnabled : enabled;

  const handleToggle = () => {
    if (loading) {
      return;
    }
    const next = !isEnabled;
    setOptimisticEnabled(next);
    fnUpdateNotificationPreferences(
      { transaction_completed_email: next },
      () => setOptimisticEnabled(null),
      () => setOptimisticEnabled(enabled),
    );
  };

  return (
    <div className="notification-preferences notification-preferences--account">
      <div className="notification-preferences__strip">
        <div className="notification-preferences__strip-head">
          <Bell className="notification-preferences__strip-icon" size={22} strokeWidth={1.35} aria-hidden />
          <h3 className="notification-preferences__strip-title">{l('notificationPreferences.title')}</h3>
        </div>
      </div>
      <div className="notification-preferences__account-body">
        <div className="notification-preferences__account-main">
          <div className="notification-preferences__account-field-label">
            {l('notificationPreferences.salesEmail.label')}
          </div>
          <div className="notification-preferences__account-field-value">
            {isEnabled
              ? l('notificationPreferences.status.enabled')
              : l('notificationPreferences.status.disabled')}
          </div>
        </div>
        <div className="notification-preferences__account-switch">
          <Switch checked={isEnabled} onChange={handleToggle} disabled={loading} />
        </div>
      </div>
    </div>
  );
};

NotificationPreferences.propTypes = {
  loading: PropTypes.bool,
  fnUpdateNotificationPreferences: PropTypes.func,
};

NotificationPreferences.defaultProps = {
  loading: false,
  fnUpdateNotificationPreferences: () => {},
};

const mapStateToProps = state => ({
  loading: state.profile.notificationPreferencesLoading,
});

const mapDispatchToProps = dispatch => ({
  fnUpdateNotificationPreferences: (notificationPreferences, onSuccess, onError) =>
    dispatch(updateNotificationPreferences(notificationPreferences, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPreferences);
